import { HeadingBlockComponent } from '../../../components/ui/heading.block.component'
import { StepCard } from '../../../components/ui/info.card.component'
import clipboardApprove from '../../../styles/icons/clipboard-approve.svg'
import consultation from '../../../styles/icons/consultation.svg'
import hireMe from '../../../styles/icons/hire-me.svg'
import signingDocument from '../../../styles/icons/signing-document.svg'
import useWindowWidth from '../../../utils/use.window.width'
import * as styled from './styled'

export const ProcessStepsComponent = () => {

	const windowWidth = useWindowWidth()
	const isMobile = windowWidth <= 1024
	
	return (
		<styled.ProcessStepsContainer>
			<HeadingBlockComponent label='Як працює' title='Контакт-Центр' />
			<styled.ProcessStepsCardsList >
				<StepCard
				
					number='1'
					title='Приймаємо звернення'
					icon={<img src={signingDocument} alt='icon' />}
				>
					{isMobile ? 
					 <styled.CardColumns>
						<styled.CardColumn>
						<styled.Label>через <br/> онлайн-портал:</styled.Label>
					<styled.Text>1580.zp.gov.ua</styled.Text>
					</styled.CardColumn>
					<styled.List>
						<styled.Label>або за телефонами:</styled.Label>
						<styled.ListItem>
							• 15-80 <small>(зі стаціонарних)</small>
						</styled.ListItem>
						<styled.ListItem>• (061) 787 15 80</styled.ListItem>
						<styled.ListItem>• (050) 414 15 80</styled.ListItem>
						<styled.ListItem>• (067) 656 15 80</styled.ListItem>
					</styled.List>
					 </styled.CardColumns>
				: <>
					
					<styled.Label>через онлайн-портал:</styled.Label>
					<styled.Text>1580.zp.gov.ua</styled.Text>

					<styled.List>
						<styled.Label>або за телефонами:</styled.Label>
						<styled.ListItem>
							• 15-80 <small>(зі стаціонарних)</small>
						</styled.ListItem>
						<styled.ListItem>• (061) 787 15 80</styled.ListItem>
						<styled.ListItem>• (050) 414 15 80</styled.ListItem>
						<styled.ListItem>• (067) 656 15 80</styled.ListItem>
					</styled.List>
					</>}
					
				</StepCard>
				<StepCard
					number='2'
					title='Передаємо виконавцям'
					icon={<img src={hireMe} alt='icon' />}
				>
					{isMobile ?
					<styled.CardText>
						Оператори Контакт-центру <br/> опрацьовують звернення та скеровують <br/> їх
						профільним службам на виконання
					</styled.CardText> : 
					<styled.CardText>
						Оператори Контакт-центру опрацьовують звернення та скеровують їх
						профільним службам на виконання
					</styled.CardText> }
					
				</StepCard>
				<StepCard
					number='3'
					title='Повідомляємо про результат'
					icon={<img src={clipboardApprove} alt='icon' />}
				>
					<styled.CardText>
						Після проведення робіт повідомимо вам результат і запитаємо вашу
						оцінку
					</styled.CardText>
				</StepCard>
				<StepCard
					number='4'
					title='Консультуємо та інформуємо'
					icon={<img src={consultation} alt='icon' />}
				>
					{isMobile ? 
					<styled.CardText>
						Надаємо консультаціїї та повідомляємо  <br/>  про планові аварійні роботи <br/> 
						комунальних служб у місті Запоріжжі
					</styled.CardText> : 
					<styled.CardText>
						Надаємо консультаціїї та повідомляємо про планові аварійні роботи
						комунальних служб у місті Запоріжжі
					</styled.CardText>
					}
					
				</StepCard>
			</styled.ProcessStepsCardsList>
		</styled.ProcessStepsContainer>
	)
}
